import React from 'react';
import PropTypes from 'prop-types';
import { Form as FormikForm, FormItem, Input } from 'formik-antd';
import {
  AddressAutoCompleteForm,
  useAddressData,
} from 'components/address-auto-complete';

import StagePropTypes from './prop-types';
import { DB_PREFIX } from './constants';

const Form = ({ values, setFieldValue, children }) => {
  const {
    [DB_PREFIX]: { address },
  } = values || {};
  const { postCode } = address || {};
  const prefix = `${DB_PREFIX}.address.`;

  const handleAddressData = useAddressData({
    setFieldValue,
    prefix,
  });

  return (
    <FormikForm layout="vertical">
      <FormItem label="Name of Organisation" name={`${DB_PREFIX}.name`}>
        <Input name={`${DB_PREFIX}.name`} placeholder="Org" />
      </FormItem>

      <AddressAutoCompleteForm
        prefix={prefix}
        input={postCode}
        setAddressData={handleAddressData}
      />

      {children}
    </FormikForm>
  );
};

Form.propTypes = {
  values: StagePropTypes.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  children: PropTypes.node,
};

Form.defaultProps = {
  children: null,
};

export default Form;
